import React from "react"
import {twMerge} from "tailwind-merge"

import {AKlaraDashboardDealChipValues} from "../../../services/types.generated.ts"
import {statusLabel, TKlaraDisplayStatus} from "../status.ts"

const STATUS_CLASS_NAME: Record<TKlaraDisplayStatus, string> = {
  [AKlaraDashboardDealChipValues.Missing]: "border-cr-red-soft bg-cr-red-faint text-cr-red-text",
  [AKlaraDashboardDealChipValues.Overdue]: "border-cr-red-pale bg-cr-red-pale text-cr-red-text",
  [AKlaraDashboardDealChipValues.Rotten]: "border-cr-yellow-pale bg-cr-yellow-pale text-cr-yellow-deep",
  [AKlaraDashboardDealChipValues.Planned]: "border-cr-blue-light bg-cr-blue-light text-cr-blue-dark",
  [AKlaraDashboardDealChipValues.Won]: "border-cr-green-pale bg-cr-green-pale text-cr-green-dark",
  [AKlaraDashboardDealChipValues.Lost]: "border-cr-slate-6 bg-cr-slate-6 text-cr-slate-60",
}

/** A deal's display label as a coloured pill; the lead drawer shows the same pill. */
export const StatusPill: React.FC<{status: TKlaraDisplayStatus; className?: string}> = ({status, className}) => (
  <span
    className={twMerge(
      "inline-block self-start rounded-full border px-2 py-0.5 text-[11.5px] font-semibold whitespace-nowrap",
      STATUS_CLASS_NAME[status],
      className
    )}
  >
    {statusLabel(status)}
  </span>
)
